import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import momentjs from 'moment-jalaali';
import { numberWithCommas } from '../../../../utils/consts';

const LastActivities = ({ LastActivitiesList, language }) => {
  return (
    <div
      className="col-12 flex-column d-flex bg-primary"
      style={{
        minHeight: '18.7rem',
        borderRadius: '1.2rem',
      }}
    >
      <div className="py-2 d-flex justify-content-between text-white  ">
        <div className="col-8 d-flex p-2">
          <FormattedMessage id="dashboard.lastactivities" />
        </div>
      </div>
      {LastActivitiesList &&
        LastActivitiesList.length > 0 &&
        LastActivitiesList.map((activity, index) => (
          <div
            key={index}
            className="w-100 d-flex align-items-center text-white my-2"
          >
            <div className="col-2 p-0">
              <div
                className="rounded-circle d-flex align-items-center justify-content-center"
                style={{
                  background: '#4179e9',
                  width: '2.8rem',
                  height: '2.8rem',
                  rotate: '-2%',
                }}
              >
                <i className={`${activity.icon} `}></i>
              </div>
            </div>
            <div className="col-5 d-flex flex-column align-items-start">
              <span className="font-small">
                <FormattedMessage id={activity.type} />
              </span>
              <span className="font-smaller  text-third">
                {activity.description[language.name]
                  ? activity.description[language.name]
                  : activity.description['en']}
              </span>
            </div>
            <div className="col-5 d-flex flex-column" d-flex flex-column>
              <span className="font-small" style={{ direction: 'ltr' }}>
                {numberWithCommas(Number(activity.price / 10).toFixed(0))}
              </span>
              <span className="font-smaller text-third">
                {language.direction === 'ltr'
                  ? activity.date.split('T')[0]
                  : momentjs(activity.date.split('T')[0]).format(
                      'jYYYY-jMM-jDD',
                    )}
              </span>
            </div>
          </div>
        ))}
      {/* <div className="d-flex align-items-center py-3 justify-content-end ">
        <Link
          style={{ color: "#c6c0e2" }}
          className="font-weight-bold text-lowercase font-smaller border-bottom"
          to="./charge-wallet"
        >
          <FormattedMessage id="dashboard.showmore" />
        </Link>
      </div> */}
    </div>
  );
};
LastActivities.propTypes = {
  LastActivitiesList: PropTypes.array,
  language: PropTypes.object,
};
LastActivities.defaultProps = {
  LastActivitiesList: [],
  language: {},
};
export default injectIntl(LastActivities);
